import { ShieldOff } from 'lucide-react'

import { Button } from '@/components/ui/button'

/** Shown instead of a page the staff member may not open (the server would refuse its data anyway). */
export const NoPermission = () => (
  <div className="flex min-h-[70vh] items-center justify-center p-4">
    <div className="flex max-w-md flex-col items-center text-center">
      <div className="mb-6 flex size-40 items-center justify-center rounded-full bg-subdued" aria-hidden="true">
        <ShieldOff className="size-16 text-faint" strokeWidth={1.25} />
      </div>
      <h1 className="text-heading-md text-ink">You don't have access to this page</h1>
      <p className="mt-1 text-sm text-text-2">Ask an admin to add this permission to your role.</p>
      <Button asChild className="mt-4">
        <a href="/">Go to home</a>
      </Button>
    </div>
  </div>
)
